import BlocTeam from './blocTeam';

export default BlocTeam;
